import { motion } from "framer-motion";

/**
 * Masked line-by-line reveal for headings.
 * Each child (usually a <span> or short phrase) becomes its own line
 * inside an overflow-hidden clip and animates up on mount.
 */
export function LineMask({ children, delay = 0, className = "" }) {
  return (
    <span className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block will-change-transform"
        initial={{ y: "110%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay }}
      >
        {children}
      </motion.span>
    </span>
  );
}

/**
 * Kinetic word reveal — splits a phrase by spaces and staggers each word.
 * Preserves any inline element inside a word via a wrapper span.
 */
export function KineticText({ text, className = "", wordClass = "", delay = 0 }) {
  const words = text.split(" ");
  return (
    <span className={`inline-block ${className}`}>
      {words.map((w, i) => (
        <span key={i} className="inline-block overflow-hidden align-top mr-[0.25em]">
          <motion.span
            className={`inline-block will-change-transform ${wordClass}`}
            initial={{ y: "115%", opacity: 0 }}
            animate={{ y: "0%", opacity: 1 }}
            transition={{ duration: 0.85, ease: [0.22, 1, 0.36, 1], delay: delay + i * 0.06 }}
          >
            {w}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

/**
 * Simple in-view fade + rise wrapper, one shot.
 */
export function Rise({ children, delay = 0, y = 40, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.85, ease: [0.22, 1, 0.36, 1], delay }}
    >
      {children}
    </motion.div>
  );
}
